import  { useState } from 'react';
import { 
 
  Typography, 
  Grid, 
  Paper, 
  Button, 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Chip,
  Container,
  Stepper,
  Step,
  StepLabel
} from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import Layout from '../components/layout/Calayout';

const TaskApprovalFlow = () => {
  const [openApprovalDialog, setOpenApprovalDialog] = useState(false);
  const [selectedTask, setSelectedTask] = useState(null);

 
  const [taskData, ] = useState([
    {
      id: 1,
      taskName: 'Q1 Financial Audit',
      assignedTo: 'John Doe',
      currentStage: 'Initial Review',
      status: 'In Progress',
      priority: 'High',
      stages: ['Initial Review', 'Senior Partner Review', 'Final Approval']
    },
    {
      id: 2,
      taskName: 'Corporate Tax Filing',
      assignedTo: 'Jane Smith',
      currentStage: 'Senior Partner Review',
      status: 'Pending Approval',
      priority: 'Medium',
      stages: ['Initial Review', 'Senior Partner Review', 'Final Approval']
    },
    {
      id: 3,
      taskName: 'Compliance Report',
      assignedTo: 'Mike Johnson',
      currentStage: 'Initial Review',
      status: 'Not Started',
      priority: 'Low',
      stages: ['Initial Review', 'Senior Partner Review', 'Final Approval']
    }
  ]);

  const getStatusColor = (status) => {
    switch(status) {
      case 'In Progress': return 'warning';
      case 'Pending Approval': return 'info';
      case 'Completed': return 'success';
      case 'Not Started': return 'default';
      default: return 'default';
    }
  };

  const columns = [
    { 
      field: 'taskName', 
      headerName: 'Task Name', 
      flex: 1 
    },
    { 
      field: 'assignedTo', 
      headerName: 'Assigned To', 
      flex: 1 
    },
    { 
      field: 'currentStage', 
      headerName: 'Current Stage', 
      flex: 1 
    },
    { 
      field: 'status', 
      headerName: 'Status', 
      flex: 1,
      renderCell: (params) => (
        <Chip 
          label={params.value} 
          color={getStatusColor(params.value)}
          variant="outlined"
        />
      )
    },
    { 
      field: 'priority', 
      headerName: 'Priority', 
      flex: 1,
      renderCell: (params) => {
        const priorityColor = {
          'High': 'error',
          'Medium': 'warning',
          'Low': 'default'
        }[params.value];
        
        return (
          <Chip 
            label={params.value} 
            color={priorityColor} 
            size="small" 
          />
        );
      }
    },
    {
      field: 'actions',
      headerName: 'Actions',
      flex: 1,
      renderCell: (params) => (
        <Button
          variant="outlined"
          color="primary"
          size="small"
          onClick={() => {
            setSelectedTask(params.row);
            setOpenApprovalDialog(true);
          }}
        >
          View Approval Flow
        </Button>
      )
    }
  ];

  const handleCloseApprovalDialog = () => {
    setOpenApprovalDialog(false);
    setSelectedTask(null);
  };

  const handleApproveTask = () => {

    handleCloseApprovalDialog();
  };

  return (
    <Layout>
      <Container maxWidth="xl">
        <Typography variant="h4" gutterBottom>
          Task Approval Flow
        </Typography>

        <Paper sx={{ width: '100%', mb: 2 }}>
          <DataGrid
            rows={taskData}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            disableSelectionOnClick
            autoHeight
          />
        </Paper>

        <Dialog
          open={openApprovalDialog}
          onClose={handleCloseApprovalDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle>Task Approval Flow: {selectedTask?.taskName}</DialogTitle>
          <DialogContent>
            <Grid container spacing={2} sx={{ mt: 1 }}>
              <Grid item xs={12}>
                <Stepper activeStep={selectedTask?.stages.indexOf(selectedTask?.currentStage)} alternativeLabel>
                  {selectedTask?.stages.map((stage) => (
                    <Step key={stage}>
                      <StepLabel>{stage}</StepLabel>
                    </Step>
                  ))}
                </Stepper>
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseApprovalDialog} color="secondary">
              Close
            </Button>
            <Button onClick={handleApproveTask} color="primary" variant="contained">
              Approve Task
            </Button>
          </DialogActions>
        </Dialog>
      </Container>
    </Layout>
  );
};

export default TaskApprovalFlow;